import React from 'react';
import { SvgIcon } from '@mui/material';

const LowPriorityRoundedNull = props => (
  <SvgIcon {...props} viewBox="-2 -4 24 24">
    <g>
      <path
        d="M12.998 1.853h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1z"
        fill="#B7BCC5"
      />
      <path
        clipRule="evenodd"
        d="M14.713 9.353l-1.968-1.968A.993.993 0 0113 7.353h6c.55 0 1 .45 1 1s-.45 1-1 1h-4.286zM15.384 12.853h-2.386c-.55 0-1 .45-1 1s.45 1 1 1h4.385l-.16-.16-1.839-1.84zm4.42 1.59l-1.591-1.59h.785c.55 0 1 .45 1 1 0 .22-.072.425-.194.59z"
        fill="#B7BCC5"
        fillRule="evenodd"
      />
      <path
        d="M7.849 16.003l1.79-1.79c.2-.2.2-.51 0-.71l-1.79-1.79a.495.495 0 00-.85.35v3.59c0 .44.54.66.85.35z"
        fill="#B7BCC5"
      />
      <path
        clipRule="evenodd"
        d="M4.659 2.119c-2.947.874-5.034 3.789-4.6 7.094.42 3.28 3.37 5.64 6.67 5.64h.27v-2h-.3c-2.35 0-4.45-1.71-4.68-4.05a4.51 4.51 0 014.373-4.95L4.66 2.12zm4.534 1.714l-1.98-1.98h1.786c.55 0 1 .45 1 1 0 .483-.348.89-.806.98z"
        fill="#B7BCC5"
        fillRule="evenodd"
      />
      <path
        d="M3.12.56a.996.996 0 10-1.41 1.41L3.04 3.3l12.65 12.66 1.33 1.33c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41L3.12.56z"
        fill="#B7BCC5"
      />
    </g>
  </SvgIcon>
);

export default LowPriorityRoundedNull;
